import { memo } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import CrabSetting0 from '@/assets/icons/CrabSetting0';
import CrabSetting90 from '@/assets/icons/CrabSetting90';
import { HALF_PI, NUMERIC_TOLERANCE as EPSILON } from '@/helpers/angleConstants';

type Props = {
  value: number | null; // if value null, value is 'mixed'
  onChange: (value: number) => void;
  disabled?: boolean;
};

function getToggleValue(value: number | null): '0' | '90' | null {
  if (value === null) return null;
  if (Math.abs(value) < EPSILON) return '0';
  if (Math.abs(value - HALF_PI) < EPSILON) return '90';
  return null;
}

function CrabSettingInputComponent({ value, onChange, disabled = false }: Props) {
  return (
    <ToggleButtonGroup
      exclusive
      size='small'
      disabled={disabled}
      value={getToggleValue(value)}
      onChange={(_, newValue: '0' | '90' | null) => {
        if (newValue === null) return;
        onChange(newValue === '0' ? 0 : HALF_PI);
      }}
    >
      <ToggleButton value='0'>
        <CrabSetting0 width={36} height={23} />
      </ToggleButton>
      <ToggleButton value='90'>
        <CrabSetting90 width={36} height={23} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export const CrabSettingInput = memo(CrabSettingInputComponent);
